import type {
  HistoryLicense,
  Language,
} from '@openeducation/oe-rn-shared-types';
import { styled } from '@openeducation/oe-rn-themes';
import React, { useCallback } from 'react';
import { FlatList, StyleProp, View, ViewStyle } from 'react-native';

import LicenseHistoryListItem, {
  LicenseHistoryListItemProps,
} from './license-history-list-item';
import { flex } from '../../style-utils';

export interface LicenseHistoryListProps {
  data: HistoryLicense[];
  activeLicenseName: string;
  labels: LicenseHistoryListItemProps['labels'];
  language: Language;
  contentStyle?: StyleProp<ViewStyle>;
  accentColor?: string;
}

export const LicenseHistoryList = ({
  data,
  activeLicenseName,
  labels,
  contentStyle,
  accentColor,
  language,
}: LicenseHistoryListProps) => {
  const renderItem = useCallback(
    ({ item }: { item: HistoryLicense }) => {
      const isActive = item.name === activeLicenseName;
      return (
        <LicenseHistoryListItem
          {...item}
          isActive={isActive}
          language={language}
          labels={labels}
          accentColor={accentColor}
        />
      );
    },
    [activeLicenseName, language, labels, accentColor]
  );

  const keyExtractor = useCallback((item: HistoryLicense) => item.name, []);

  return (
    <View style={[flex('flex-1')]}>
      <View style={[flex('flex-row'), contentStyle]}>
        <Timeline accentColor={accentColor} />
        <FlatList
          data={data}
          keyExtractor={keyExtractor}
          renderItem={renderItem}
        />
      </View>
    </View>
  );
};

type TimelineType = {
  accentColor?: string;
};

const Timeline = styled.View<TimelineType>`
  width: 2px;
  background-color: ${({ theme, accentColor }) =>
    accentColor || theme.color.primary};
  left: 5px;
  position: absolute;
  height: 100%;
`;

export default LicenseHistoryList;
